import { USER_ACTIONS } from "@/api/queries/userActions";
import { useQuery, ApolloError } from "@apollo/client";
import { RiseUserAction } from "@/types/RiseUserAction";
import { getDateString } from "@/util/dateUtils";

const PAGE_SIZE = 50;

export const useUserActions = (
  userId: string | undefined,
  orgId: string | undefined,
  date: Date,
): {
  loading: boolean;
  actions: RiseUserAction[] | null;
  error?: ApolloError;
} => {
  const dateStr = getDateString(date);

  const {
    data: actionsData,
    loading,
    error,
  } = useQuery(USER_ACTIONS, {
    variables: {
      orgId: orgId || "",
      userId: userId || "",
      date: dateStr,
      first: PAGE_SIZE,
    },
    skip: !orgId || !userId,
  });

  let actions: RiseUserAction[] | undefined = [];
  const node = actionsData?.node;
  if (node?.__typename === "User") {
    actions = node.actions?.edges
      ?.map((edge) => {
        const action: RiseUserAction | null | undefined = edge?.node;
        return action;
      })
      .filter((action) => !!action);
  }

  return {
    actions: actions || null,
    loading,
    error,
  };
};
